import React, {Component} from 'react';
import {Button, Col, Glyphicon, Row} from 'react-bootstrap';
import {handleTypeheadSearch, TypeheadField} from "./form";
import {createDogOption, resolveApiResult} from "../../utils";
import DogForm from "../dog/DogForm";
import {connect} from "react-redux";
import {findDogs, loadDog, saveDog} from "../../actions/dogs";
import {showMessage} from "../../actions";
import {showModal} from "../../actions/modal";
import PropTypes from "prop-types";
import {DogVariant} from "../../utils/enums";

class DogField extends Component {

	findDogsTimeout = null;

	constructor(props) {
		super(props);

		this.state = {
			initialDog: null,
			dogModalOpen: null,
			dogId: null
		}
	}

	componentWillMount() {
		const {input: {value}} = this.props;
		if (value) {
			this.props.loadDog(value).then((json) => {
				if (resolveApiResult(json)) {
					this.setState({initialDog: json.response.data});
				} else {
					this.setState({initialDog: false});
				}
			});
		} else {
			this.setState({initialDog: false});
		}
	}

	componentWillUnmount() {
		if (this.findDogsTimeout) {
			clearTimeout(this.findDogsTimeout);
		}
	}

	handleDogModalClick(dogId) {
		this.setState({dogModalOpen: true, dogId})
	}

	handleDogModalDismiss() {
		this.setState({dogModalOpen: false, dogId: null})
	}

	handleFindDogs(search, callback, currentDog = null) {
		if (this.findDogsTimeout) {
			clearTimeout(this.findDogsTimeout);
		}
		this.findDogsTimeout = setTimeout(() => {
			const f = {search};
			if (this.props.variant === DogVariant.MOTHER) {
				f['sex'] = 'F';
			}
			handleTypeheadSearch(f, createDogOption, this.props.findDogs, callback, currentDog);
		}, search ? 500 : 0);
	}

	createNewDog() {
		switch (this.props.variant) {
			case DogVariant.MOTHER:
				return {
					sex: 'F',
					status: 1
				};
			default:
				return {
					status: 1,
					breedId: 439,
					sex: 'F',
					birthDate: 2009
				};
		}
	}

	renderDogModal() {
		const {input, variant} = this.props;
		const {dogModalOpen, dogId} = this.state;
		if (!dogModalOpen) {
			return null;
		}

		const modal = {
			type: 'dog',
			onHide: () => this.handleDogModalDismiss(),
			onSuccess: (d) => {
				this.setState({initialDog: d}, () => {
					input.onChange(d.dogId);
				});
			}
		}

		const dog = dogId
			? {dogId}
			: this.createNewDog();

		return <DogForm
			variant={variant}
			form={'dog-' + input.name}
			dog={dog}
			modal={modal}/>
	}

	render() {
		const {
			input,
			sizes,
			variant,
			clearable = false,
			...props
		} = this.props;
		const {initialDog} = this.state;

		return (
			<Row>
				<Col sm={8}>
					<TypeheadField {...props}
						input={input}
						sizes={[3, 9]}
						key={JSON.stringify(initialDog)}
						clearable={clearable}
						emptyText="(není)"
						loadOptions={(i, c) => this.handleFindDogs(i, c, initialDog)}
						searchPromptText={variant === DogVariant.MOTHER ? "Jméno matky" : "Zadejte jméno"}/>
				</Col>
				<Col sm={4}>
					{input.value
						? <Button type="button" className="btn btn-info"
							onClick={() => this.handleDogModalClick(input.value)}>
							<Glyphicon glyph="pencil"/> {'Upravit zvíře'}</Button>
						: <Button type="button" className="btn btn-info"
							onClick={() => this.handleDogModalClick(null)}>
							<Glyphicon glyph="plus"/> {'Nové zvíře'}</Button>
					}
					{this.renderDogModal()}
				</Col>
			</Row>
		);
	}
}

const mapStateToProps = (state) => {
	const {
		enums,
		session
	} = state;

	return {
		enums,
		session
	}
}

DogField.propTypes = {
	variant: PropTypes.string.isRequired,
	findDogs: PropTypes.func.isRequired,
	loadDog: PropTypes.func.isRequired,
	saveDog: PropTypes.func.isRequired,
	showModal: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	enums: PropTypes.object.isRequired,
	session: PropTypes.object.isRequired
};

export default connect(mapStateToProps, {
	findDogs,
	loadDog,
	saveDog,
	showMessage,
	showModal
})(DogField)



// WEBPACK FOOTER //
// ./src/components/form/DogField.js